module.exports = __webpack_public_path__ + "img/lg_ring_y_c_0_null@2x.e7ad0222.png";